const {
  serviceOptions: commonServiceOptions,
} = require('./__generated__/CommonApi');
const {
  serviceOptions: frontServiceOptions,
} = require('./__generated__/FrontApi');
const { default: axios } = require('axios');
const dayjs = require('dayjs');
const customParseFormat = require('dayjs/plugin/customParseFormat');
const { configure } = require('mobx');

if (typeof window !== 'undefined') {
  if (window.location.hostname === 'm.unicef.or.kr') {
    window.location.href = "https://www.unicef.or.kr"
  }
}

// dayjs 초기화
require('dayjs/locale/ko');

dayjs.locale('ko');
dayjs.extend(customParseFormat);

// axios 초기화
const instance = axios.create({
  baseURL: process.env.BACKEND_URL,
  timeout: 300000,
  withCredentials: true,
  paramsSerializer(paramObj) {
    const params = new URLSearchParams();
    // eslint-disable-next-line no-restricted-syntax
    for (const key in paramObj) {
      if (paramObj[key] !== undefined) {
        // 배열형태 데이터 처리
        if (Array.isArray(paramObj[key])) {
          paramObj[key].map((v) => params.append(key, v));
        } else {
          params.append(key, paramObj[key]);
        }
      }
    }
    return params.toString();
  },
});
// 기본 axios 인스턴스에도 withCredentials 설정 (직접 axios 호출 대응)
axios.defaults.withCredentials = true;
// 기존 localStorage 토큰 정리 (세션 쿠키 전환)
if (typeof window !== 'undefined') {
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
}

frontServiceOptions.axios = instance;
commonServiceOptions.axios = instance;

// mobx 초기화
// IE11 호환 설정
configure({ useProxies: 'never' });
